import {
  Order,
  OrderDocumentType,
  OrderReturnStatus,
  OrderStatus,
  OrderType,
} from '../../../../clients/quipli-service/order/order';
import { ProductTrackingType } from '../../../../clients/quipli-service/product/product';
import { Dropdown } from '../../../../components/dropdown/dropdown';
import { Button } from '../../../../components/form/button';
import Icon from '../../../../components/icons/icon';
import { Typography } from '../../../../components/typography/typography';
import { Constants } from '../../../../constants/constants';
import { DownloadMenu } from './download-menu';
import { PrintMenu } from './print-menu';

export const ContractHeader = ({
  order,
  showRates,
  setShowRates,
  setIsRentalDatesModalOpen,
  isQrCodeEnabled,
  setScanQrModalOpen,
  isCustomSecurityDepositEnabled,
  setIsSecurityDepositModalOpen,
  hasPermissions,
  isSuperAdmin,
  setIsBufferPeriodModalOpen,
  setIsAddLineItemModalOpen,
  setIsConvertToModalOpen,
}: {
  order: Order;
  showRates: boolean;
  setShowRates: (arg: boolean) => void;
  setIsRentalDatesModalOpen: (arg: boolean) => void;
  isQrCodeEnabled: boolean;
  setScanQrModalOpen: React.Dispatch<
    React.SetStateAction<{
      open: boolean;
      isManualEntry: boolean;
      manualEntry: string;
      isSubmitting: boolean;
    }>
  >;
  isCustomSecurityDepositEnabled: boolean;
  setIsSecurityDepositModalOpen: (arg: boolean) => void;
  setIsBufferPeriodModalOpen: (arg: boolean) => void;
  setIsAddLineItemModalOpen: (arg: boolean) => void;
  setIsConvertToModalOpen: (arg: boolean) => void;
  hasPermissions: (arg: string) => boolean;
  isSuperAdmin: boolean;
}) => {
  return (
    <>
      {order.products.some((op) => op.type === OrderType.Rental) && order.documentType == OrderDocumentType.Order && (
        <>
          <div>
            {' '}
            <DownloadMenu order={order} />
          </div>
          <div>
            {' '}
            <PrintMenu order={order} />
          </div>
        </>
      )}

      <div className="inline-flex sm:hidden grow"></div>

      {order.documentType == OrderDocumentType.Order && (
        <div>
          <Dropdown
            placement="bottom-end"
            trigger={() => (
              <Button className="button button-tertiary">
                <Icon icon="DotsHorizontal" />
              </Button>
            )}
          >
            <div onClick={() => setShowRates(!showRates)}>
              <Typography dataCy="show-rates" type="text-sm" className="text-quipli-black-800">
                {showRates ? 'Hide Rates' : 'Show Rates'}
              </Typography>
            </div>

            {order.returnStatus !== OrderReturnStatus.Complete && (
              <div onClick={() => setIsRentalDatesModalOpen(true)}>
                <Typography dataCy="adjust-rental-dates" type="text-sm" className="text-quipli-black-800">
                  Adjust All Rental Dates
                </Typography>
              </div>
            )}

            {isQrCodeEnabled &&
              order?.products.some(
                (op) =>
                  op.type === OrderType.Rental &&
                  op.product.trackingType === ProductTrackingType.SerialUnits &&
                  (!op.status || op.status === OrderReturnStatus.NotStarted),
              ) && (
                <div
                  onClick={() => {
                    setScanQrModalOpen((prev) => ({ ...prev, open: true, isSubmitting: false }));
                  }}
                >
                  <Typography dataCy="scan-unit" type="text-sm" className="text-quipli-black-800">
                    Scan Unit
                  </Typography>
                </div>
              )}

            {(isCustomSecurityDepositEnabled || order.rentalSecurity !== 0) &&
              ![OrderStatus.Cancelled, OrderStatus.Missed].includes(order.status) && (
                <div onClick={() => setIsSecurityDepositModalOpen(true)}>
                  <Typography type="text-sm" className="text-quipli-black-800">
                    Set Custom Security Deposit
                  </Typography>
                </div>
              )}

            {(hasPermissions(Constants.Permissions.Order_Buffer_Period) || isSuperAdmin) &&
              ![OrderStatus.Cancelled, OrderStatus.Missed].includes(order.status) && (
                <div
                  onClick={() => {
                    setIsBufferPeriodModalOpen(true);
                  }}
                >
                  <Typography type="text-sm" className="text-quipli-black-800">
                    Add Buffer Period
                  </Typography>
                </div>
              )}

            {(hasPermissions(Constants.Permissions.Refund_Upcharge_Order) || isSuperAdmin) && (
              <div onClick={() => setIsAddLineItemModalOpen(true)}>
                <Typography type="text-sm" className="text-quipli-black-800">
                  Add Line Item
                </Typography>
              </div>
            )}

            {!order.isCycleBilled &&
              !order.products
                .filter((op) => op.type === OrderType.Rental)
                .every((op) => op.status === OrderReturnStatus.Complete) && (
                <div onClick={() => setIsConvertToModalOpen(true)}>
                  <Typography type="text-sm" className="text-quipli-black-800">
                    Convert to Cycle Bill
                  </Typography>
                </div>
              )}
          </Dropdown>
        </div>
      )}
    </>
  );
};
